















import { Button } from "vant";

export default {
  name: "PopupHeader",
  components: {
    [Button.name]: Button
  },
  props: {
    title: {
      type: String
    },
    closeable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      (this as any).$emit("close");
    }
  }
};
